"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeDropdown = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var types_1 = require("../types");
var Dropdown_1 = require("../../Dropdown");
var List_1 = require("../../List");
var MeasureDropdown_1 = require("../MeasureDropdown/MeasureDropdown");
var icons = (_a = {},
    _a[types_1.SORT_TARGET_TYPE.ALPHABETICAL_ASC] = "gd-icon-sort-alphabetical-asc",
    _a[types_1.SORT_TARGET_TYPE.ALPHABETICAL_DESC] = "gd-icon-sort-alphabetical-desc",
    _a[types_1.SORT_TARGET_TYPE.NUMERICAL_ASC] = "gd-icon-sort-numerical-asc",
    _a[types_1.SORT_TARGET_TYPE.NUMERICAL_DESC] = "gd-icon-sort-numerical-desc",
    _a);
var getIconClassNameBySelection = function (sortType) { return icons[sortType]; };
var getSortTypeItems = function (available, intl) {
    var sortTypeItems = [];
    if (available.attributeSort.normalSortEnabled) {
        sortTypeItems.push({
            id: types_1.SORT_TARGET_TYPE.ALPHABETICAL_ASC,
            title: intl.formatMessage({ id: "sorting.type.alphabetical.asc" }),
            sortDirection: "asc",
            type: "alphabetical",
            localIdentifier: available.itemId.localIdentifier,
        }, {
            id: types_1.SORT_TARGET_TYPE.ALPHABETICAL_DESC,
            title: intl.formatMessage({ id: "sorting.type.alphabetical.desc" }),
            sortDirection: "desc",
            type: "alphabetical",
            localIdentifier: available.itemId.localIdentifier,
        });
    }
    if (available.attributeSort.areaSortEnabled ||
        (available.metricSorts && available.metricSorts.length > 0)) {
        sortTypeItems.push({
            id: types_1.SORT_TARGET_TYPE.NUMERICAL_ASC,
            title: intl.formatMessage({ id: "sorting.type.numerical.asc" }),
            sortDirection: "asc",
            type: "numerical",
            localIdentifier: available.itemId.localIdentifier,
        }, {
            id: types_1.SORT_TARGET_TYPE.NUMERICAL_DESC,
            title: intl.formatMessage({ id: "sorting.type.numerical.desc" }),
            sortDirection: "desc",
            type: "numerical",
            localIdentifier: available.itemId.localIdentifier,
        });
    }
    return sortTypeItems;
};
var getButtonValue = function (sortTypeItems, type, direction) {
    return sortTypeItems.find(function (sortTypeItems) { return sortTypeItems.id === type + "-" + direction; });
};
exports.AttributeDropdown = function (_a) {
    var currentSortItem = _a.currentSortItem, availableSorts = _a.availableSorts, bucketItemNames = _a.bucketItemNames, intl = _a.intl, index = _a.index, onSelect = _a.onSelect, disabledExplanationTooltip = _a.disabledExplanationTooltip, enableRenamingMeasureToMetric = _a.enableRenamingMeasureToMetric;
    var _b = tslib_1.__read(react_1.useState(0), 2), width = _b[0], setWidth = _b[1];
    var _c = tslib_1.__read(react_1.useState(currentSortItem), 2), currentItem = _c[0], setCurrentItem = _c[1];
    var buttonRef = react_1.useRef(null);
    react_1.useEffect(function () {
        if (buttonRef && buttonRef.current) {
            setWidth(buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current.getBoundingClientRect().width);
        }
    }, []);
    var attributeSelectHandler = react_1.useCallback(function (item) {
        var newCurrentItem;
        if (item.type === "alphabetical") {
            newCurrentItem = sdk_model_1.newAttributeSort(item.localIdentifier, item.sortDirection);
        }
        else if (availableSorts.attributeSort.areaSortEnabled) {
            newCurrentItem = sdk_model_1.newAttributeAreaSort(item.localIdentifier, item.sortDirection);
        }
        else {
            newCurrentItem = sdk_model_1.newMeasureSort(item.localIdentifier, item.sortDirection);
        }
        setCurrentItem(newCurrentItem);
        onSelect(newCurrentItem);
    }, [currentItem, setCurrentItem, onSelect]);
    var measureSelectHandler = react_1.useCallback(function (newCurrentItem) {
        setCurrentItem(newCurrentItem);
        onSelect(newCurrentItem);
    }, [currentItem, setCurrentItem, onSelect]);
    var sortTypeItems = getSortTypeItems(availableSorts, intl);
    var currentType = sdk_model_1.isAttributeSort(currentItem) && !sdk_model_1.isAttributeAreaSort(currentItem) ? "alphabetical" : "numerical";
    var direction = sdk_model_1.sortDirection(currentItem);
    var buttonValue = getButtonValue(sortTypeItems, currentType, direction);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Dropdown_1.Dropdown, { closeOnMouseDrag: true, closeOnParentScroll: true, renderButton: function (_a) {
                var isOpen = _a.isOpen, toggleDropdown = _a.toggleDropdown;
                return (react_1.default.createElement("div", { ref: buttonRef },
                    react_1.default.createElement(Dropdown_1.DropdownButton, { className: "s-sort-type-attribute-button-" + index + " s-" + currentType + "-dropdown-button", value: buttonValue.title, isOpen: isOpen, onClick: toggleDropdown, iconLeft: getIconClassNameBySelection(currentType + "-" + direction) })));
            }, renderBody: function (_a) {
                var closeDropdown = _a.closeDropdown;
                return (react_1.default.createElement(Dropdown_1.DropdownList, { className: "gd-attribute-sorting-dropdown-body s-attribute-sorting-dropdown-body", items: sortTypeItems, width: width, renderItem: function (_a) {
                        var item = _a.item;
                        var isSelected = item.id === currentType + "-" + direction;
                        var iconClass = getIconClassNameBySelection(item.type + "-" + item.sortDirection);
                        return (react_1.default.createElement(List_1.SingleSelectListItem, { isSelected: isSelected, className: iconClass, title: item.title, onClick: function () {
                                attributeSelectHandler(item);
                                closeDropdown();
                            } }));
                    } }));
            } }),
        currentType === "numerical" && (react_1.default.createElement(MeasureDropdown_1.MeasureDropdown, { currentItem: currentItem, intl: intl, availableSorts: availableSorts, bucketItemNames: bucketItemNames, onSelect: measureSelectHandler, disabledExplanationTooltip: disabledExplanationTooltip, enableRenamingMeasureToMetric: enableRenamingMeasureToMetric }))));
};
//# sourceMappingURL=AttributeDropdown.js.map